import React, { useEffect, useState } from "react";
import { Phone, Mail } from "lucide-react";
import { Link } from "react-router-dom";
import i18n from "../i18n";

const Footer = () => {
  const [langTick, setLangTick] = useState(0);

  useEffect(() => {
    const onLang = () => setLangTick((x) => x + 1);
    i18n.on("languageChanged", onLang);
    return () => i18n.off("languageChanged", onLang);
  }, []);

  // eslint-disable-next-line no-unused-vars
  const _ = langTick;

  const footerLinks = [
    { name: i18n.t("footer.links.about"), href: "#about" },
    { name: i18n.t("footer.links.solutions"), href: "#solutions" },
    { name: i18n.t("footer.links.references"), href: "#references" },
    { name: i18n.t("footer.links.jobs"), to: "/jobs" }
  ];

  return (
    <footer className="bg-gradient-to-b from-[#050825] to-[#060A40] text-white py-16">
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-20 flex flex-col md:flex-row justify-between gap-12">
        <div className="flex-1 flex flex-col">
          <div>
            <h2 className="text-4xl font-bold text-gray-400 leading-snug mb-6">
              {i18n.t("footer.title.line1")}
              <br />
              <span className="text-white">{i18n.t("footer.title.line2")}</span>
            </h2>

            <div className="flex flex-col text-gray-300 mb-8 leading-tight">
              <div className="flex items-center gap-2">
                <Phone size={18} />
                <a href="tel:+43664207630" className="hover:underline">
                  +43 (0) 664 207630
                </a>
              </div>

              <div className="flex items-center gap-2">
                <Mail size={18} />
                <a href="mailto:office@shark-soft.com" className="hover:underline">
                  office@shark-soft.com
                </a>
              </div>
            </div>

            <div className="hidden md:block mt-20">
              <img
                src={`${process.env.PUBLIC_URL}/logos/Sharklogo2.png`}
                alt="Shark Logo"
                className="h-4 mb-2"
              />
              <div className="flex flex-col text-sm text-gray-400 leading-tight">
                <p>{i18n.t("footer.copyright")}</p>
                <p className="mt-1">
                  {i18n.t("footer.companyData.firmenbuch")}: 102782a |{" "}
                  {i18n.t("footer.companyData.uid")}: ATU 16134403
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="flex flex-col gap-2 min-w-[140px]">
          <h3 className="text-lg font-bold mb-2">{i18n.t("footer.companyTitle")}</h3>

          {footerLinks.map((link, index) =>
            link.to ? (
              <Link key={index} to={link.to} className="text-gray-300 hover:text-white">
                {link.name}
              </Link>
            ) : (
              <a key={index} href={link.href} className="text-gray-300 hover:text-white">
                {link.name}
              </a>
            )
          )}
        </div>
      </div>

      <div className="block md:hidden mt-12 px-4 sm:px-6 lg:px-20">
        <img
          src={`${process.env.PUBLIC_URL}/logos/Sharklogo2.png`}
          alt="Shark Logo"
          className="h-4 mb-1"
        />
        <div className="flex flex-col text-sm text-gray-400 leading-tight">
          <p>{i18n.t("footer.copyright")}</p>
          <p className="mt-1">
            {i18n.t("footer.companyData.firmenbuch")}: 102782a |{" "}
            {i18n.t("footer.companyData.uid")}: ATU 16134403
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;











